import eventService from '@/services/events.svc'
import stripeService from '@/services/stripe.svc'
import Datepicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css';
import generateRandom8DigitNumber from '@/utils/randomNumber.util'; '@/utils/randomNumber.util';
import { createOrder } from '@/services/orders.svc'
import { loadStripe } from '@stripe/stripe-js';

export default {
  name: 'AdditionalItems',

  components: {
    Datepicker
  },

  data() {
    return {
      stripe: null,
      cardElement: null,
      cardComplete: false,
      cardError: '',
      stripeApiKey: '',
      showForm: false,
      orderStatus: '',
      items: [],
      children: [
        {
          name: '',
          shirtSize: '',
          diet:''
        }
      ],
      eventName: '',
      street: '',
      city: 'Herriman',
      state: 'UT',
      zip: '84096',
      eventId: 0,
      baseCost: 0,
      ticketPrice: 0,
      isLoading: true,
      isSaving: false,
      type: 'camps',
      notes: '',
      phone: '',
      email: '',
      parentName: '',
      mediaRelease: {
        checked: false,
        id: 0,
      },
      liability: {
        checked: false,
        id: 0,
      }
    }
  },

  created() {
    if(this.isLocalhost) {
      this.mediaRelease.checked = true
      this.liability.checked = true
      this.showForm = true
    }

    stripeService.getStripeApiKey().then(data => {
      this.stripeApiKey = data.key;
      loadStripe(this.stripeApiKey).then(stripe => {
        this.stripe = stripe;
      });
    })
  },

  async mounted() {
    try {
      const { key } = await stripeService.getStripeApiKey();
      this.stripeApiKey = key;
      this.stripe = await loadStripe(this.stripeApiKey);
      
      if (!this.stripe) {
        console.error('Stripe failed to load');
        this.cardError = 'Payment system failed to load. Please refresh and try again.';
        return;
      }
      
      const elements = this.stripe.elements({
        locale: 'auto'
      });
      this.cardElement = elements.create('card', {
        hidePostalCode: false,
        style: {
          base: {
            fontSize: '16px',
            fontFamily: 'Arial, sans-serif'
          }
        }
      });
      
      const paymentFormRow = document.getElementById('payment-form-row');
      if (!paymentFormRow) {
        console.error('Payment form container not found');
        return;
      }
      
      this.cardElement.mount('#payment-form-row');
      
      // Listen for card changes
      this.cardElement.addEventListener('change', (event) => {
        if (event.error) {
          this.cardError = event.error.message;
          this.cardComplete = false;
        } else {
          this.cardError = '';
          this.cardComplete = event.complete;
        }
      });
    } catch (error) {
      console.error('Error mounting Stripe card element:', error);
      this.cardError = 'Error loading payment form. Please try again.';
    }
    //$('#start-date-picker, #end-date-picker, #event-date-picker').datepicker()
    const costsContainer = document.querySelector('.tribe-events-cost')?.innerHTML.replace('$','').trim() || 0
    this.type = document.querySelector('.type')?.innerHTML.trim() || 'camp'

    const postContainer = document.querySelector('.tribe_events')
    let currentEventId = postContainer?.getAttribute('id')?.replace('post-', '') || 0
    if(this.getQueryParam('eventId')) {
      currentEventId = this.getQueryParam('eventId')
    }
    if(!isNaN(costsContainer) && currentEventId) {
      this.eventId = currentEventId
      this.baseCost = !this.isLocalhost ? parseInt(costsContainer) : 123
      eventService.getItemsByEventId(this.eventId).then(data => {
        this.items = data.map(item => {
          return {
            ...item,
            Qty: 0
          }
        })
      }).finally(() => {
        this.isLoading = false
      })
    } else {
      this.isLoading = false
    }

    window.addEventListener('message', (event) => {
      if(event?.data?.type === 'liability') {
        this.liability.checked = event.data.accepted
        this.liability.id = event.data.id
        this.$modal.hide('liability')
      } else if(event?.data?.type === 'mediaRelease') {
        this.mediaRelease.checked = event.data.accepted
        this.mediaRelease.id = event.data.id
        this.$modal.hide('media-release')
      }
    })
  },

  computed: {
    isLocalhost() {
      return location.href.includes('localhost')
    },

    ticketQty() {
      return this.children.length
    },

    kidsEnabled() {
      return this.$root?.kidsEnabled || false
    },

    dietEnabled() {
      return this.$root?.dietEnabled || false
    },

    total() {
      const qtyTotal = this.items.reduce((acc, item) => acc + parseInt(item.Cost) * parseInt(item.Qty), 0)
      const grandTotal = parseInt(qtyTotal) + (parseInt(this.baseCost) * this.ticketQty)
      return grandTotal
    },

    cleanThumbnail() {
      return (item) => item.Thumbnail.replaceAll('?', ' ')
    },

    hasContactInfo() {
      return this.phone.length > 0 && this.email.length > 0 && this.parentName.length > 0 && this.street.length > 0 && this.city.length > 0 && this.state.length > 0 && this.zip.length > 0
    },

    disabled() {
      const isValid = !this.ticketQty <= 0 && this.hasContactInfo
      const hasItems = this.items.length === 0 || this.items.filter(item => item.Qty > 0).length > 0
      const hasEmptyChildInfo = this.children.filter(child => child.name.length === 0).length > 0 && this.kidsEnabled
      return !isValid || !hasItems || hasEmptyChildInfo || !this.liability.checked || !this.mediaRelease.checked
    },

    isCamp() {
      if(this.getQueryParam('type')) {
        return this.getQueryParam('type') === 'camps'
      }
      return [...document.querySelector('.tribe_events')?.classList || []]?.findIndex(c => c.includes('-camps')) > 0 || false
    },

    childrenNames() {
      return this.children.map(child => child.name).join(',')
    },

    queryString() {
      return `&street=${this.street}&city=${this.city}&state=${this.state}&zip=${this.zip}&parent=${this.parentName}&children=${this.childrenNames}&phone=${this.phone}&email=${this.email}`
    },

    startDate() {
      return document.querySelector('.tribe-event-date-start')?.innerHTML || ''
    },

    buttonText() {
      return this.showForm ? 'Hide' : 'Registration'
    }
  },

  methods: {
    resetData() {
      this.showForm = false
      this.items = []
      this.children = [
        {
          name: '',
          shirtSize: '',
          diet:''
        }
      ]
      this.eventName = ''
      this.ticketPrice = 0
      this.isLoading = true
      this.isSaving = false
      this.notes = ''
      this.phone = ''
      this.email = ''
      this.parentName = ''
      this.startDate = ''
      this.endDate = ''
      this.liability = {
        checked: true,
        id: 0,
      },
      this.mediaRelease = {
        checked: true,
        id: 0,
      }
    },

    addChild() {
      this.children.push({
        name: '',
        shirtSize: '',
        diet:''
      })
    },

    showFormClick() {
      this.showForm = !this.showForm
    },

    removeChild(index) {  
      if(confirm('Are you sure you want to remove this child?')) {
        this.children.splice(index, 1)
      }
    },

    updateItemQty(item, qty) {
      item.Qty = qty
    },

    selectText(event) {
      event.target.select()
    },

    getQueryParam(key) {
      const urlParams = new URLSearchParams(window.location.search)
      return urlParams.get(key)
    },

    async venmoClick() {
      this.isSaving = true;
      const lineBreak = '%0A'
      const orderId = generateRandom8DigitNumber()
      this.eventName = document.querySelector('.tribe-events-single-event-title')?.innerText || 'Localhost Event';
      const note = `GFF ${this.type} Registration${lineBreak}
      Order Id: ${orderId}${lineBreak}
      Parent: ${this.parentName}${lineBreak}
      Start Date: ${this.startDate}${lineBreak}`
      await createOrder(this.stripeApiKey,{
        UseStripe: false,
        OrderID: orderId,
        EventID: this.eventId,
        EventName: this.eventName,
        ParentName: this.parentName,
        Street: this.street,
        City: this.city,
        State: this.state,
        Zip: this.zip,
        Phone: this.phone,
        Email: this.email,
        Type: this.type,
        Total: this.total,
        Notes: this.notes,
        Children: this.children,
        AdditionalItems: this.items.filter(item => item.Qty > 0),
        MediaReleaseID: this.mediaRelease.id,
        LiabilityID: this.liability.id,
      })

      this.isSaving = false;
      this.orderStatus = 'success';

      const url = `https://venmo.com/Becky-Gillette-1?txn=pay&amount=${this.total}&note=${note.replaceAll(' ', '%20')}`
      window.open(url, '_blank')

      setTimeout(() => {
        this.orderStatus = '';
        this.resetData();
        location.reload();
      }, 3000)
    },

    async submitPaymentClick() {
      this.isSaving = true;
      this.cardError = '';

      try {
        if (!this.stripe || !this.cardElement) {
          throw new Error('Payment system not initialized');
        }

        // Create PaymentMethod from card element (for PaymentIntent API)
        const { paymentMethod, error } = await this.stripe.createPaymentMethod({
          type: 'card',
          card: this.cardElement,
          billing_details: {
            name: this.parentName,
          }
        });

        if (error) {
          console.error('PaymentMethod creation error:', error.message);
          this.cardError = error.message || 'Card validation failed. Please check your card details.';
          this.isSaving = false;
          return;
        }

        if (!paymentMethod) {
          throw new Error('Payment method creation returned no data');
        }

        this.eventName = document.querySelector('.tribe-events-single-event-title')?.innerText || 'Localhost Event';
        const orderId = generateRandom8DigitNumber();

        const orderData = {
          UseStripe: true,
          OrderID: orderId,
          EventID: this.eventId,
          EventName: this.eventName,
          ParentName: this.parentName,
          Street: this.street,
          City: this.city,
          State: this.state,
          Zip: this.zip,
          Phone: this.phone,
          Email: this.email,
          Type: this.type,
          Total: this.total,
          Notes: this.notes,
          Children: this.children,
          MediaReleaseID: this.mediaRelease.id,
          LiabilityID: this.liability.id,
          AdditionalItems: this.items.filter(item => item.Qty > 0),
          PaymentInfo: {
            payment_method_id: paymentMethod.id  // Send payment method ID to backend
          }
        };

        await createOrder(this.stripeApiKey, orderData);

        this.orderStatus = 'success';
        this.isSaving = false;

        setTimeout(() => {
          this.orderStatus = '';
          this.resetData();
          location.reload();
        }, 3000);
      } catch (error) {
        console.error("Order creation failed", error);
        this.cardError = error.message || 'Payment processing failed. Please try again.';
        this.orderStatus = 'error';
        this.isSaving = false;
      }
    }
  }
}